import { defineStore, acceptHMRUpdate } from "pinia"

import { ref } from "vue"
import { useStorage } from "@vueuse/core"
import type { Config } from "@/types/general"

export const useMainStore = defineStore("main", () => {
    const appId = "atlas-prahy"
    const mobileMode = ref(innerWidth <= 640)
    const config = ref<Config | null>(null)
    const mode = ref<"2d" | "3d">("2d")
    const locale = ref<"cs" | "en">("cs")
    const uiHidden = ref(false)
    const activeWidgetId = ref<string | null>(null)
    const activeBasemapId = ref<string | null>(null)
    const essentialSourcesReady = ref(false) // tokens + sources + config
    const viewReady = ref(false)
    const basemapsReady = ref(false)
    const identifyBlocked = ref(false)
    const helpWindowOpen = ref(false)
    const sceneSettings = useStorage("scene-settings", {
        quality: 2 as 1 | 2 | 3,
        groundOpacity: 1,
        edgesEnabled: true,
        shadowsEnabled: true,
        treesEnabled: true,
        waterEnabled: false,
        buildingsEnabled: true,
        elevationExaggeration: false,
        weather: "sunny" as "sunny" | "cloudy" | "rainy" | "snowy" | "foggy",
    })
    const cookiesBannerActive = ref(false)
    const cookiesSettingsModalActive = ref(false)
    const cookiesPermissions = ref({
        technical: false,
        analytical: false,
    })
    const gaId = "G-N1CHDHL9RT"

    async function fetchConfig() {
        try {
            const response = await fetch("./config.json")
            const data = (await response.json()) as Config
            config.value = data
            return config
        } catch (error) {
            console.log(error)
        }
    }

    return {
        appId,
        mobileMode,
        config,
        mode,
        locale,
        uiHidden,
        activeWidgetId,
        activeBasemapId,
        essentialSourcesReady,
        viewReady,
        basemapsReady,
        identifyBlocked,
        helpWindowOpen,
        sceneSettings,
        cookiesBannerActive,
        cookiesSettingsModalActive,
        cookiesPermissions,
        gaId,
        fetchConfig,
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMainStore, import.meta.hot))
}
